<template>
    <div v-resize="onResize">
        <loader v-if="loading" />        
        <template v-if="!loading && data.length > 0">
        <h2>Two candidate preferred (TCP) for {{ division }} ({{ state }})</h2>
        <br/>
            <chart :chartData="chartData"/>
            <br/>
            <v-data-table :headers="headers"                    
                :items="data"
                :disable-initial-sort="true"
                :hide-headers="isMobile"
                :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
                hide-actions>
                <template v-slot:items="props">
                    <tr v-if="isMobile">
                        <td>
                            <div class="flex-content">
                                <div class="flex-item pt-2">
                                    <h3 class="pb-xs-0">
                                        <span v-if="!props.item.Phid">{{ props.item.Candidate }}</span>
                                        <router-link v-if="props.item.Phid" :to="{ name: 'Parliamentarian', params: { PHID: props.item.Phid } }">
                                            {{ props.item.Candidate }}
                                        </router-link>
                                    </h3>
                                </div>
                                <div class="flex-item flex-item-col" data-label="Party">
                                    <span v-if="!props.item.PartyLinked || props.item.Status != 'Elected'">{{ props.item.Party }}</span>
                                    <router-link v-if="props.item.PartyLinked && props.item.Status == 'Elected'" :to="{ name: 'Party', params: { Party: props.item.PartyLinked }}">
                                        {{ props.item.PartyLinkedName }}
                                    </router-link>
                                </div>
                                <div class="flex-item flex-item-col" v-if="props.item.Status != ''" data-label="Status">
                                    {{ props.item.Status }}
                                </div>
                                <div class="flex-item flex-item-col" v-if="props.item.Status == ''" >
                                    <!-- Leave empty -->
                                </div>
                                <div class="flex-item flex-item-col flex-item-col-20" data-label="Votes">
                                    {{ props.item.Votes }}
                                </div>
                                <div class="flex-item flex-item-col flex-item-col-20" data-label="Margin">
                                    {{ props.item.Margin }}
                                </div>
                                <div class="flex-item flex-item-col flex-item-col-40" data-label="This election (%)">
                                    {{ props.item.ThisElectionPercentage }}
                                </div>
                                <div class="flex-item flex-item-col flex-item-col-20" v-if="showSwing" data-label="Swing (%)">
                                    {{ props.item.Swing }}
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-else>
                        <td class="text-xs-left">
                            <span v-if="!props.item.Phid">{{ props.item.Candidate }}</span>
                            <router-link v-if="props.item.Phid" :to="{ name: 'Parliamentarian', params: { PHID: props.item.Phid } }">
                                {{ props.item.Candidate }}
                            </router-link>
                        </td>
                        <td class="text-xs-left">
                            <span v-if="!props.item.PartyLinked || props.item.Status != 'Elected'">{{ props.item.Party }}</span>
                            <router-link v-if="props.item.PartyLinked && props.item.Status == 'Elected'" :to="{ name: 'Party', params: { Party: props.item.PartyLinked }}">
                                {{ props.item.PartyLinkedName }}
                            </router-link>
                        </td>
                        <td class="text-xs-left">{{ props.item.Votes }}</td>
                        <td class="text-xs-left">{{ props.item.Margin }}</td>
                        <td class="text-xs-left">{{ props.item.ThisElectionPercentage }}</td>
                        <td class="text-xs-left" v-if="showSwing">{{ props.item.Swing }}</td>
                        <td class="text-xs-left">{{ props.item.Status }}</td>
                    </tr>
                </template>
            </v-data-table> 
        </template>                     
    </div>
</template>
<script>
import Loader from '@/components/Loader.vue';
import Chart from '../StatisticalInformation/Chart.vue';
import axios from 'axios';
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

export default {
    props: ['division', 'state', 'year', 'electionId'],
    components: {
        Chart,
        Loader
    },
    created() {
        this.initialiseData();
       
    },
    mounted() {
        this.onResize();
    },
    data() {
        return {
            isMobile: false,
            data: [],
            loading: true
        }
    },
    methods: {
        onResize() {
            if (window.innerWidth < 769){
                this.isMobile = true;
            }
            else{
                this.isMobile = false;
            }
        },
        initialiseData: function () {
            this.loading = true;
            const url = `Elections/TwoCandidatePreferred?divisionName=${this.division}&year=${this.year}&electionId=${this.electionId}`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.data = response.data;
                    this.loading = false;
                    this.$emit('loaded', this.data.length > 0);
                });
        }
    },
    computed: {
        headers() {
            const headers = [{
                text: 'Candidate',
                value: 'Candidate'
            },
            {
                text: 'Party',
                value: 'Party'
            },
            {
                text: 'Votes',
                value: 'Votes'
            },
            {
                text: 'Margin',
                value: 'Margin'
            },            
            {
                text: 'This election (%)',
                value: 'Votes'
            },            
            {
                text: 'Status',
                value: 'Status'
            }]
            if (this.showSwing) {
                headers.splice(headers.length - 1, 0, {
                    text: 'Swing',
                    value: 'Swing'
                });
            }
            return headers;
        },
        showSwing() {
            return this.data.findIndex(d => d.Swing > 0) !== -1;
        },
        chartData() {
            return {
                chart: {
                    type: 'bar',
                    plotBackgroundColor: null,
                    plotBorderWidth: 0,
                    plotShadow: false,
                    backgroundColor: null,
                    height: 170
                },
                title: {
                    text: undefined
                },
                xAxis: {
                    labels: {
                        enabled: false
                    },
                },
                yAxis: {
                    title: undefined,
                    labels: {
                        enabled: false
                    },
                    plotLines: [
                        {
                            dashStyle: 'Solid',
                            color: '#808080',
                            value: 50,
                            width: 2,
                            zIndex: 4
                        }
                    ]
                },
                legend: {
                    reversed: true
                },
                plotOptions: {
                    bar: {
                        stacking: 'percent',
                        dataLabels: {
                            enabled: true,
                            format: '{point.percentage:.2f}%'
                        }
                    },
                },
                tooltip: {
                    formatter: function () {
                        return `${this.point.percentage.toFixed(2)}% - ${this.y} votes`
                    }
                },
                series: [...this.data].reverse().map(d => ({
                    name: d.Candidate,
                    color: d.PartyColour,
                    data: [d.Votes],
                    events: {
                        legendItemClick: function(e) {
                            e.preventDefault()
                        }
                    }
                }))
            }
        }
    }
}

</script>